import React from 'react';

import {Drawer} from 'presentation/components/Drawer';
import {translations} from 'presentation/translations-new';

import {useMediaQueries} from 'presentation/pages';
import {CertificationDetailsDrawerProps} from './types';
import {Typography} from '@mui/material';

const {
	drawer: {title, description1, description2},
} = translations['pt-br'].privateFlow.bookingFlow.qualityCertificationBanner;

export function CertificationDetailsDrawer({
	isOpen,
	onClose,
	onOpen,
}: CertificationDetailsDrawerProps) {
	const {isMobile} = useMediaQueries();

	return (
		<Drawer.Root
			open={isOpen}
			onClose={onClose}
			onOpen={onOpen}
			width="396px"
			customMaxHeight="100%"
			sx={{zIndex: 9000}}>
			<Drawer.Header onClose={onClose} title={title} />
			<Drawer.Content mt={isMobile ? 0 : 1.5} gap={1} mb={3}>
				<Typography>{description1}</Typography>
				<Typography>{description2}</Typography>
			</Drawer.Content>
		</Drawer.Root>
	);
}
